<!-- Toasts: no topo (no celular, sem cobrir a barra de salvar do rodapé) -->
<div
  class="pointer-events-none fixed inset-x-0 top-3 z-[999] flex flex-col items-center gap-2 px-4 sm:inset-x-auto sm:top-4 sm:right-4 sm:items-end sm:px-0"
  role="status"
  aria-live="polite"
>
  @for (toast of toasts(); track toast.id) {
    @let style = getToastStyle(toast);
    <div
      class="pointer-events-auto flex w-full max-w-sm items-start gap-3 rounded-2xl border border-gray-200 bg-white p-3 pr-2 shadow-lg shadow-gray-900/10"
      [attr.data-toast]="toast.type"
      @expandCollapse
    >
      <span
        class="flex size-8 shrink-0 items-center justify-center rounded-full border"
        [ngClass]="[style.bgColor, style.borderColor, style.titleColor]"
      >
        <ng-icon [name]="style.icon" size="1rem" />
      </span>
      <div class="min-w-0 flex-1 py-1">
        <p class="text-sm font-semibold text-gray-900">{{ toast.title }}</p>
        @if (toast.message) {
          <p
            class="mt-0.5 text-sm text-gray-600"
            [innerHTML]="toast.message"
          ></p>
        }
      </div>
      <button
        z-button
        zType="ghost"
        zSize="icon-sm"
        type="button"
        class="shrink-0 text-gray-400 hover:text-gray-700"
        aria-label="Fechar"
        (click)="removeToast(toast)"
      >
        <ng-icon name="lucideX" size="1rem" />
      </button>
    </div>
  }
</div>
